const BellIcon = ({ fill = "#343741" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <g clip-path="url(#clip0_3116_9471)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.31646 12H12.6836C12.4964 11.2965 12.4038 10.3089 12.336 8.96349C12.2664 7.58092 12.2329 7.07529 12.1459 6.35085C12.1176 6.11535 12.0858 5.88907 12.0499 5.67021C11.7398 3.77934 10.5443 2.74815 8.34205 2.53962C8.44202 2.38395 8.5 2.19875 8.5 2C8.5 1.44772 8.05228 1 7.5 1C6.94772 1 6.5 1.44772 6.5 2C6.5 2.19876 6.55798 2.38397 6.65796 2.53964C4.45595 2.74826 3.26051 3.77944 2.95049 5.67021C2.9146 5.88907 2.88278 6.11535 2.85448 6.35086C2.76744 7.0752 2.73393 7.58064 2.66426 8.96319C2.59645 10.3088 2.50375 11.2964 2.31646 12ZM13.1586 13H1.84138C1.53255 13.3532 1.10418 13.5 0.5 13.5C0.223858 13.5 0 13.2761 0 13C0 12.7239 0.223858 12.5 0.5 12.5C1.2861 12.5 1.52423 11.7169 1.66553 8.91286C1.73642 7.50611 1.77082 6.98722 1.86163 6.23155C1.89158 5.98226 1.92538 5.74186 1.96366 5.50841C2.29841 3.46688 3.51013 2.1947 5.52002 1.71593C5.65795 0.745902 6.49187 0 7.5 0C8.5081 0 9.342 0.745856 9.47997 1.71584C11.4901 2.19454 12.7019 3.46675 13.0367 5.50841C13.075 5.74186 13.1088 5.98226 13.1387 6.23156C13.2295 6.98733 13.2639 7.50642 13.3348 8.91321C13.4759 11.717 13.714 12.5 14.5 12.5C14.7761 12.5 15 12.7239 15 13C15 13.2761 14.7761 13.5 14.5 13.5C13.8958 13.5 13.4674 13.3532 13.1586 13ZM5.5 14H9.5C9.5 15.1046 8.60457 16 7.5 16C6.39543 16 5.5 15.1046 5.5 14Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_3116_9471">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default BellIcon;
